// extracted by mini-css-extract-plugin
module.exports = {"container":"drop-file-zone_container__Fx_sK","dragOver":"drop-file-zone_dragOver__oDpL0","error":"drop-file-zone_error__5mzjI"};